module.exports = __webpack_public_path__ + "/login_ui/img/sc-44e6715601f903eb75e6f3c408919aed.svg";